import { AbstractControl } from '@angular/forms';

export class EmailValidator {
  public static validate(c: AbstractControl) {
    if (!c.value) {
      return null;
    }

    const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return EMAIL_REGEXP.test(String(c.value).trim())
      ? null
      : {
        emailValidator: {
          valid: false
        }
      };
  }
}
